const DEFAULT_CHUNK_SIZE_MB = 8;

export interface FileChunk {
  blob: Blob;
  partNumber: number; // 1-indexed
  start: number;
  end: number;
  size: number;
}

/**
 * Split a File into Blob chunks for S3 multipart upload.
 * @param file - The file to split
 * @param chunkSizeMB - Chunk size in MB (default: 8 MB)
 */
export function chunkFile(
  file: File,
  chunkSizeMB = DEFAULT_CHUNK_SIZE_MB
): FileChunk[] {
  const chunkSize = chunkSizeMB * 1024 * 1024;
  const chunks: FileChunk[] = [];
  let offset = 0;
  let partNumber = 1;

  while (offset < file.size) {
    const end = Math.min(offset + chunkSize, file.size);
    chunks.push({
      blob: file.slice(offset, end),
      partNumber,
      start: offset,
      end,
      size: end - offset,
    });
    offset = end;
    partNumber++;
  }

  return chunks;
}
